import { Button, Group, Loader, Stack, TextInput } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import {
  IconArrowLeft,
  IconBuildingCommunity,
  IconBuildingStore,
  IconChevronDown,
  IconSearch,
  IconUsersGroup,
} from "@tabler/icons-react";
import { Link, useParams } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";
import PopOver from "../../../../components/View/PopOver";
import { useProfileStore } from "../../../../stores/UserStore";
import { getProfile } from "../../../../api/UserAPI";
import CommunityItem from "./CommunityItem";
import { getResellers } from "../../../../api/AdminAPI";

const CommunityDropdown = ({
  type = "resellers",
  getClickLink,
  getDeletedLink,
}) => {
  const lang = useLanguage((s) => s.language);
  const { resellerId, teamId, orgId } = useParams();
  const [loading, setLoading] = useState(true);
  const items = useProfileStore((s) => s.profile[type]);
  const profile = useProfileStore((s) => s.profile);

  const [searchItems, setSearchItems] = useState(items || []);

  const active = useMemo(() => {
    if (type === "resellers") {
      if (profile?.level === "admin") {
        return searchItems.find((x) => x.id === parseInt(resellerId));
      }
      return items.find((x) => x.id === parseInt(resellerId));
    }
    if (type === "teams") {
      return items.find((x) => x.id === parseInt(teamId));
    }
    return items.find((x) => x.id === parseInt(orgId));
  }, [items, orgId, profile?.level, resellerId, searchItems, teamId, type]);

  const handleInput = (e) => {
    let search = e.target.value;

    let filtered = items.filter((x) => {
      let nameContained = x.name.toLowerCase().includes(search.toLowerCase());

      return nameContained;
    });

    setSearchItems(filtered);
  };

  const handleOpen = () => {
    setSearchItems(items);
    setLoading(true);
    setTimeout(() => {
      document.getElementById("search-folder-input").focus();
    }, 100);
  };

  useEffect(() => {
    if (loading) {
      if (type === "resellers" && profile?.level === "admin") {
        getResellers()
          .then((res) => {
            let data = res.data.domains_list;
            let final = [];
            data.forEach((element) => {
              let same_ids = data.filter(
                (x) => x.reseller_id === element.reseller_id
              );
              let add = {
                id: element.reseller_id,
                name: element.name,
                domain_saas: same_ids.find((x) => x.type === "saas")?.domain,
                domain_saas2: same_ids.find((x) => x.type === "saas2")?.domain,
                domain_saas_status: same_ids.find((x) => x.type === "saas")
                  ?.status,
                domain_saas2_status: same_ids.find((x) => x.type === "saas2")
                  ?.status,
                domain_saas_status_date: same_ids.find((x) => x.type === "saas")
                  ?.domain_saas_status_date,

                domain_files: same_ids.find((x) => x.type === "files")?.domain,
                domain_files_status: same_ids.find((x) => x.type === "files")
                  ?.status,
                domain_files_status_date: same_ids.find(
                  (x) => x.type === "files"
                )?.domain_saas_status_date,

                domain_redirect: same_ids.find((x) => x.type === "redirect")
                  ?.domain,
                domain_redirect_status: same_ids.find(
                  (x) => x.type === "redirect"
                )?.status,
                domain_redirect_status_date: same_ids.find(
                  (x) => x.type === "redirect"
                )?.domain_saas_status_date,

                domain_api: same_ids.find((x) => x.type === "api")?.domain,
                domain_api_status: same_ids.find((x) => x.type === "api")
                  ?.status,
                domain_api_status_date: same_ids.find((x) => x.type === "api")
                  ?.domain_saas_status_date,
                number_of_users: element.number_of_users,
                number_of_users_activated: element.number_of_users_activated,
              };

              if (!final.find((x) => x.id === element.reseller_id))
                final.push(add);
            });

            setSearchItems(final);
          })
          .finally(() => setLoading(false));
      } else {
        getProfile()
          .then((r) => setSearchItems(r.data.user_profile[type]))
          .finally(() => setLoading(false));
      }
    }
  }, [loading, profile?.level, type]);

  return (
    <Group wrap="nowrap" w={300}>
      <Button
        size="md"
        w={48}
        p={0}
        component={Link}
        to={type === "resellers" ? "/resellers" : `/settings/${type}`}
      >
        <IconArrowLeft size={24} />
      </Button>

      <PopOver
        opener={(opener, ref) => (
          <Button
            style={{ zIndex: 8 }}
            w={"100%"}
            leftSection={
              loading ? (
                <Loader color="#fff" size={24} />
              ) : type === "resellers" ? (
                <IconBuildingStore size={24} />
              ) : type === "organizations" ? (
                <IconBuildingCommunity size={24} />
              ) : (
                <IconUsersGroup size={24} />
              )
            }
            rightSection={<IconChevronDown />}
            justify="space-between"
            size="md"
            onClick={(e) => {
              handleOpen();
              opener(e);
            }}
            ref={ref}
          >
            {active?.name}
          </Button>
        )}
        popoverChildren={(handleClose) => (
          <Stack gap={0} w={360} >
            <TextInput
              mb={16}
              pos={"relative"}
              id="search-folder-input"
              placeholder={lang.global.search}
              leftSection={<IconSearch size={16} />}
              data-autofocus
              onChange={handleInput}
            />
            <Stack pos={"relative"} mih={200} mah={400} gap={"xs"} >
              {searchItems.map((item) => (
                <CommunityItem
                  key={item.id}
                  item={item}
                  type={type}
                  setOpened={() => handleClose(false)}
                  setLoading={setLoading}
                  getClickLink={getClickLink}
                  getDeletedLink={getDeletedLink}
                />
              ))}
              {/* <Group
                pos={"absolute"}
                bottom={0}
                right={0}
                style={{ zIndex: 16 }}
              >
                <FolderAdder
                  type={type}
                  onFinish={onFolderCreated}
                  isPool={isPool}
                />
              </Group> */}
            </Stack>
          </Stack>
        )}
      />
    </Group>
  );
};

export default CommunityDropdown;
